package one.healthium.common.di

import one.healthium.common.mapper.ColorMapper
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val dataCommonModule = module {
    factoryOf(::ColorMapper)
}